import { module } from 'stereomodularjs';
import svgIco from '../components/svgIco.vue'
import NewCarFeatures from '../components/NewCarFeatures.vue'
import { createApp } from "vue/dist/vue.esm-bundler.js"

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;
       
        const app = createApp({
            template: '<NewCarFeatures />',
            components: { svgIco, NewCarFeatures },
            data() {
                return {
                    spriteURL: self.el.dataset.sprite
                }
            },
            methods: {

            },
            computed: {

            },
            watch: {

            },
            mounted() { },
        })
        
        app.component("svgIco", svgIco)

        app.mount(self.el)
        setTimeout(() => {
            if (window.trim) document.$trigger('trimChanged', { trim: window.trim });
        }, 0);
        
    }
}
